import { useQuery } from 'react-query';

import { axios } from 'lib';

const getExclusionSuppliers = (frameworkAgreementId, lotId) => {
  return axios.get(
    `/api/framework_agreements/${frameworkAgreementId}/setup/lots/${lotId}/exclusions/suppliers`
  );
};

export const useExclusionSuppliers = (frameworkAgreementId, lotId, options = {}) => {
  return useQuery(
    `framework_agreements-${frameworkAgreementId}-setup-lots-${lotId}-exclusion-suppliers`,
    () => getExclusionSuppliers(frameworkAgreementId, lotId),
    {
      //@ts-ignore
      initialData: { data: { data: [] } },
      select: ({ data }) => data.data,
      ...options,
    }
  );
};
